import React from "react"
import { VehicleDetailsBasicResponse } from "../../api/endpoints/vehicleDetails/basic-types"
import { Action } from "../store"

const addReg = (dispatch: React.Dispatch<Action>) => (registration: string) => {
  dispatch({
    type: "ADD_REG",
    data: registration,
  })
}

const addVehicleCondition =
  (dispatch: React.Dispatch<Action>) => (vehicleCondition: any) => {
    dispatch({
      type: "ADD_VEHICLE_CONDITION",
      data: vehicleCondition,
    })
  }

const addContactDetails =
  (dispatch: React.Dispatch<Action>) => (contactDetails: any) => {
    dispatch({
      type: "ADD_CONTACT_DETAILS",
      data: contactDetails,
    })
  }

const addAppointmentDetails =
  (dispatch: React.Dispatch<Action>) => (appointmentDetails: any) => {
    dispatch({
      type: "ADD_APPOINTMENT_DETAILS",
      data: appointmentDetails,
    })
  }
const addMileage = (dispatch: React.Dispatch<Action>) => (mileage: any) => {
  dispatch({
    type: "ADD_MILEAGE",
    data: mileage,
  })
}

const addWhichVehicle =
  (dispatch: React.Dispatch<Action>) => (whichVehicle: any) => {
    dispatch({
      type: "ADD_WHICH_VEHICLE",
      data: whichVehicle,
    })
  }

const addWhichVehicleType =
  (dispatch: React.Dispatch<Action>) => (whichVehicleType: any) => {
    dispatch({
      type: "ADD_WHICH_VEHICLE_TYPE",
      data: whichVehicleType,
    })
  }

const addAuth = (dispatch: React.Dispatch<Action>) => (auth: any) => {
  dispatch({
    type: "ADD_AUTH",
    data: auth,
  })
}

const addValuation = (dispatch: React.Dispatch<Action>) => (valuation: any) => {
  dispatch({
    type: "ADD_VALUATION",
    data: valuation,
  })
}

export const addVehicleDetails =
  (dispatch: React.Dispatch<Action>) =>
  (vehicleDetails: VehicleDetailsBasicResponse.RootObject) => {
    dispatch({
      type: "ADD_VEHICLE_DETAILS",
      data: vehicleDetails,
    })
  }

const addTermsConditions =
  (dispatch: React.Dispatch<Action>) => (termsConditions: any) => {
    dispatch({
      type: "ADD_TERMS_CONDITIONS",
      data: termsConditions,
    })
  }

const addBookingStatus =
  (dispatch: React.Dispatch<Action>) => (bookingStatus: string) => {
    dispatch({
      type: "ADD_BOOKING_STATUS",
      data: bookingStatus,
    })
  }

const addBookingDate =
  (dispatch: React.Dispatch<Action>) => (bookingDate: string) => {
    dispatch({
      type: "ADD_BOOKING_DATE",
      data: bookingDate,
    })
  }

const addBookingTime =
  (dispatch: React.Dispatch<Action>) => (bookingTime: string) => {
    dispatch({
      type: "ADD_BOOKING_TIME",
      data: bookingTime,
    })
  }

const addLead = (dispatch: React.Dispatch<Action>) => (data: any) => {
  dispatch({
    type: "ADD_LEAD",
    data: data,
  })
}

const addClosestDealerships =
  (dispatch: React.Dispatch<Action>) => (data: any) => {
    dispatch({
      type: "ADD_CLOSEST_DEALERSHIPS",
      data: data,
    })
  }

const addDealershipGuid = (dispatch: React.Dispatch<Action>) => (data: any) => {
  dispatch({
    type: "ADD_DEALERSHIP_GUID",
    data: data,
  })
}

const addDealershipUrl = (dispatch: React.Dispatch<Action>) => (data: any) => {
  dispatch({
    type: "ADD_DEALERSHIP_URL",
    data: data,
  })
}

const addGroupId = (dispatch: React.Dispatch<Action>) => (groupId: number) => {
  dispatch({
    type: "ADD_GROUP_ID",
    data: groupId,
  })
}

const addValuationLimit =
  (dispatch: React.Dispatch<Action>) => (limitReached: boolean) => {
    dispatch({
      type: "ADD_LIMIT_REACHED",
      data: limitReached,
    })
  }

const addStockAuth = (dispatch: React.Dispatch<Action>) => (stockAuth: any) => {
  dispatch({
    type: "ADD_STOCK_AUTH",
    data: stockAuth,
  })
}

const addExistsInStock = (dispatch: React.Dispatch<Action>) => (existsInStock: any) => {
  dispatch({
    type: "ADD_EXISTS_IN_STOCK",
    data: existsInStock,
  })
}

const resetState =
  (dispatch: React.Dispatch<Action>) => (data: any) => {
    dispatch({
      type: "RESET_STATE",
      data,
    })
  }

export const createActions = (dispatch: React.Dispatch<Action>) => ({
  addReg: addReg(dispatch),
  addVehicleDetails: addVehicleDetails(dispatch),
  addVehicleCondition: addVehicleCondition(dispatch),
  addContactDetails: addContactDetails(dispatch),
  addAppointmentDetails: addAppointmentDetails(dispatch),
  addMileage: addMileage(dispatch),
  addWhichVehicle: addWhichVehicle(dispatch),
  addWhichVehicleType: addWhichVehicleType(dispatch),
  addAuth: addAuth(dispatch),
  addValuation: addValuation(dispatch),
  addTermsConditions: addTermsConditions(dispatch),
  addBookingStatus: addBookingStatus(dispatch),
  addBookingDate: addBookingDate(dispatch),
  addBookingTime: addBookingTime(dispatch),
  addLead: addLead(dispatch),
  addGroupId: addGroupId(dispatch),
  addDealershipGuid: addDealershipGuid(dispatch),
  addDealershipUrl: addDealershipUrl(dispatch),
  addClosestDealerships: addClosestDealerships(dispatch),
  addValuationLimit: addValuationLimit(dispatch),
  addStockAuth: addStockAuth(dispatch),
  addExistsInStock: addExistsInStock(dispatch),
  resetState: resetState(dispatch)
})
